import * as yup from "yup";

export const addAndChangeSchema = (translate: Function) => yup.object().shape({
	mab001Titulo: yup.string().required(translate("Título é requerido")),
	mab001Descricao: yup.string(),
	mab001Labelagrupador: yup.string().required(translate("Agrupador é requerido")),
	mab001Ativo: yup.string().oneOf(["S", "N"]),
	mab001Ano: yup.string().required(translate("Ano é requerido")),
	matbb002: yup.array()
		.unique(translate("Concorrentes não podem ser repetidos"), (a: any) => a.mab002Taa012Id),
	matbb003: yup.array()
		.min(1,translate("Ao menos uma permissão deve ser informada"))
		.required(translate("Ao menos uma permissão deve ser informada"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.mab003Efa005Id, (a: any) => !a.mab003Efa004Id)
		.unique(translate("Grupo de Usuários não podem ser repetidos"), (a: any) => a.mab003Efa004Id, (a: any) => !a.mab003Efa005Id)
});




export const addAndChangeSchemaGrouper = (translate: Function) => yup.object().shape({
	mab004Descricao: yup.string().required(translate("Descrição é requerido")),
	mab004Explicacao: yup.string()
});

export const addAndChangeSchemaQuestion = (translate: Function) => yup.object().shape({
	mda003Questao: yup.string().required(translate("Questão é requerida")),
	mda003Descricao: yup.string().required(translate("Descrição é requerido")),
	mda003Pontuacao: yup.string().required(translate("Pontuação é requerida"))
});

export const addAndChangeSchemaAnswer = (translate: Function) => yup.object().shape({
	mda004Resposta: yup.string().required(translate("Resposta é requerida")),
	mda004Descricao: yup.string()
});

export const deleteSchema = (translate: Function) => yup.object().shape({
	mab001Titulo: yup.string().required(translate("Titulo da análise não confere")).oneOf([yup.ref("mab001TituloConfirmation")], translate("Titulo da análise não confere"))
});


